import { TFunction } from 'i18next';

export function getBulkOilDeliveryTime(t: TFunction, date: Date): string {
  const day = date.getDay();
  const hours = date.getHours();

  let businessDays: number;

  switch (day) {
    case 2:
      businessDays = hours < 18 ? 8 : 14;
      break;
    case 3:
      businessDays = 14;
      break;
    case 4:
      businessDays = 13;
      break;
    case 5:
      businessDays = 12;
      break;
    case 6:
      businessDays = 11;
      break;
    case 0:
      businessDays = 10;
      break;
    case 1:
      businessDays = 9;
      break;
    default:
      businessDays = 14;
  }

  return t('catalog.reference.stock.within_xx_business_days', 'Within {{count}} business days', {
    count: businessDays,
  });
}
